// PAPERLIKE FORK — Rebuy references stripped from gift-add handler (PATCH-DOC §6)

// PAPERLIKE-CUSTOMIZED native asset (vs vanilla Impact / theme default).
// Changes (see theme-changes/PATCH-DOC.md §6):
// - Rebuy references stripped from the gift-add success handler in handleGift() (they would throw a
//   ReferenceError once Rebuy Smart Cart is removed).
// - handleCartAttributes() cart-update URL fixed (2026-07-10): themeVariables.routes never existed, so the
//   _utmCampaign cart attribute (Autocart gift trigger) was never set by the theme — now uses Shopify.routes.root.
if (!window.customElements.get('utm-campaign-popup')) {
  class UtmCampaignPopup extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.utmCampaignParameter = this.dataset.campaignParameter;
      this.delay = parseInt(this.dataset.popupDelay);
      this.locale = this.dataset.locale;
      this.triggerPages = this.dataset.triggerPages ? JSON.parse(this.dataset.triggerPages) : [];
      this.waitForConsent(() => this.init());
    }

    waitForConsent(callback) {
      // PAPERLIKE FIX (2026-07-10): the old version listened for a click on '#pandectes-banner .cc-allow' —
      // brittle (button markup/modal variants, banner injected before the observer), so first-time visitors
      // who accepted the banner never got the popup/cart attribute. Every accept path ends with the
      // _pandectes_gdpr cookie being written, so poll for THAT instead, plus Shopify's standard
      // visitorConsentCollected event for a faster trigger. Fires the callback at most once.
      let consentHandled = false;
      let pollTimer = null;

      const hasConsent = () => {
        const cookie = document.cookie.split('; ').find(c => c.startsWith('_pandectes_gdpr='));
        if (!cookie) return false;
        try {
          const consent = JSON.parse(atob(cookie.split('=')[1]));
          return consent.status === 'allow' || consent.status === 'custom';
        } catch (e) {
          return false;
        }
      };

      const fireIfConsented = () => {
        if (consentHandled || !hasConsent()) return;
        consentHandled = true;
        if (pollTimer) clearInterval(pollTimer);
        callback();
      };

      // Returning visitor: consent cookie already present
      if (hasConsent()) {
        consentHandled = true;
        callback();
        return;
      }

      pollTimer = setInterval(fireIfConsented, 1000);
      document.addEventListener('visitorConsentCollected', fireIfConsented);
    }

    init() {
      const params = new URLSearchParams(window.location.search);
      const utmCampaign = params.get('offer');
      const currentPath = window.location.pathname;

      const matchesOffer = utmCampaign && utmCampaign === this.utmCampaignParameter;
      const matchesPage = this.triggerPages.some(page => currentPath === page || currentPath === page.replace(/\/$/, ''));

      if (!matchesOffer && !matchesPage) return;

      const storageKey = `utmCampaign:${this.utmCampaignParameter}_locale=${this.locale}`;
      const storedValue = localStorage.getItem(storageKey);
      const parsedTimestamp = parseInt(storedValue);
      const isValidTimestamp = storedValue && !isNaN(parsedTimestamp);
      const isExpired = isValidTimestamp && (Date.now() - parsedTimestamp) > 30 * 24 * 60 * 60 * 1000;

      if (!storedValue || !isValidTimestamp || isExpired) {
        setTimeout(() => {
          this.toggleVisibility(true);
          localStorage.setItem(storageKey, Date.now().toString());
        }, this.delay);
        console.log('not seen campaign');
        this.handleGift();
      }

      this.closeButton = this.querySelector('.popup-modal__close');
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.toggleVisibility(false));
      }

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) {
          this.toggleVisibility(false);
        }
      });
    }

    async handleGift() {
      this.variantId = this.dataset.giftVariantId;
      if (!this.variantId) {
        this.handleCartAttributes();
      } else {
        let formData = {
          items: [
            {
              id: this.variantId,
              quantity: 1,
              properties : {
                _utmCampaign: this.utmCampaignParameter
              }
            }
          ]
        };

        fetch(`${Shopify.routes.root}cart/add.js`, {
          body: JSON.stringify(formData),
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then((response) => response.json())
        .then((cartResponse) => {
          // Silent gift add: this raw fetch does NOT dispatch the theme's cart:change/variant:add
          // events, so the native Impact cart drawer will NOT auto-open here. We only refresh the
          // header cart count. (Previously this block also set Rebuy.SmartCart.skip_open — removed
          // with the Rebuy removal; that reference would now throw a ReferenceError.)
          const cartCount = document.querySelector('cart-count');
          if(cartCount) {
            fetch(`${Shopify.routes.root}cart.js`)
              .then((response) => response.json())
              .then((cart) => {
                console.log('setting item count from UTM popup: ', cart.item_count)
                cartCount.itemCount = cart.item_count;
              });
          }
        });
      }
    }

    handleCartAttributes() {
      const payload = {
        attributes: {
          "_utmCampaign": this.utmCampaignParameter
        }
      };

      console.log(payload)

      // PAPERLIKE FIX (2026-07-10): was `${themeVariables.routes.cartUpdateUrl}.js` — themeVariables has no
      // `routes` key in Impact 7.x, so this ALWAYS threw and the attribute was never set by the theme (live
      // included; there it was masked by an app capturing utm_campaign). Same pattern as the add.js call above.
      fetch(`${Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
      .catch(error => {
        console.error('Error adding attributes to cart:', error);
      });
    }

    toggleVisibility(show) {
      this.classList.toggle('active', show);
    }
  }

  window.customElements.define('utm-campaign-popup', UtmCampaignPopup);
}
